import { Component, OnInit, ElementRef, NgZone, AfterViewInit } from "@angular/core";
import { ExportColumnHeaders } from "@shared/models/export-headers.model";
import { MapExportData } from "@shared/data/MapExportData";
import { TabOpenService } from "@services/tab-open.service";
import { TimeZoneConverter } from "@shared/pipes/timezone-converter";
import { AgreementService } from "@fs/services/agreement/agreement.service";
import { SpinnerService } from "@shared/services/spinner.service";
import { customJS } from "@fs/services/customjs";
import { Grid } from "@fs/enums/grid.enum";
import { GridFilter } from "@fs/services/grid.mixin";
import { catchError, debounceTime, switchMap, takeUntil } from "rxjs/operators";
import { of } from "rxjs";
import { ExportService } from "@shared/services/export";
import { TabParams } from "@fs/services/tab-params.service";
import { ExportType } from "@fs/enums/common-enums";
import { Constants } from "@constants";
import { Tabs } from "@enums/tab.enum";
import { CustomerService } from "@fs/services/customer/customer.service";

@Component({
  selector: 'agreement-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
  providers: [AgreementService, TimeZoneConverter]
})
export class SaListComponent extends GridFilter implements OnInit, AfterViewInit { 
  constructor(private $elementRef: ElementRef, private agreementServ: AgreementService, private exportServ: ExportService,
              private tabopen: TabOpenService, private zone: NgZone, private customerServ: CustomerService, spinnerServ: SpinnerService) {
    super(Grid.ServiceAgreement, spinnerServ);
    //ToDo: Optimizing further requires significant changes in the exisitng services
    this.makeRequest$.pipe(
      debounceTime(Constants.debounceInterval),
      switchMap((val:string) => 
        this.agreementServ.GetServiceAgreementList(this.state, val).pipe(
          catchError(() => {
            return of({ Data: [], Count: 0 });
          })
      )), 
      takeUntil(this.ngUnsubscribe))
      .subscribe(r => {
        this.spinnerServ.hideLoader(this.gridVc, this.tabCounter);
        if (!this.isExport) this.mapGridData(r); else this.mapExportData(r); 
      });
  }

  ngOnInit() {   
    this.spinnerServ.showloader(this.gridVc, this.tabCounter, Constants.defaultSpinnertimeout, true);
    this.getData();
  }
  ngAfterViewInit() {
    this.zone.runOutsideAngular(() => {
      customJS.setScroll(this.$elementRef.nativeElement);
    });
  }
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
  viewAgreement(val) {
    this.tabopen.OpenTab(TabParams.ViewServiceAgreement(val, true));
  }
  editAgreement(val) {
    this.tabopen.OpenTab(TabParams.EditServiceAgreement(val));
  }
  openAgreementItem(id, number) {
    this.tabopen.OpenTab(TabParams.AgreementItemView(id, number));
  }
  applyFilter(filterSetting: { applyAdvanceFilter: boolean, advanceFilterActive: any } = { advanceFilterActive: true, applyAdvanceFilter: null }, isStateReset: boolean = false) {
    let filterValues = this.filterForm.controls['searchFilters'];
    let filters = jQuery.extend(true, {}, filterValues);
    filters.value.map(x => {
      if (x.field == "Length") { if (x.value2 == 'Year') { x.value = (x.value * 12).toString() }; }
    });
    this.filter(filterSetting, filters);
  }
  //#region private methods 
  private mapExportData(r) {
    this.isExport = false;
    if (this.exportType == ExportType.Excel) {
      this.exportServ.ExportToExcel({
        exportData: r.Data.map(x => MapExportData.mapServiceAgreement(x)),
        exportHeadersColumns: ExportColumnHeaders.ServiceAgreementColumns,
        columnHeaderNotToBeIncluded: []
      });
    } else if (this.exportType == ExportType.PDF) {
      this.exportServ.ExportToPDF({
        exportData: r.Data.map(x => MapExportData.mapServiceAgreement(x)),
        exportHeadersColumns: ExportColumnHeaders.ServiceAgreementColumns,
        columnHeaderNotToBeIncluded: []
      });
    } else if (this.exportType == ExportType.CSV) {
      this.exportServ.ExportToCSV({
        exportData: r.Data.map(x => MapExportData.mapServiceAgreement(x)),
        exportHeadersColumns: ExportColumnHeaders.ServiceAgreementColumns,
        columnHeaderNotToBeIncluded: []
      });
    }
  }
  //#endregion
  
  //#region cleanup
  // To Do - Tabparams can't be used for this as jobsite page requires some changes which can be done later
  viewJobSite(args) {
    this.tabopen.OpenTab({
      tabId: Tabs.FsLiteCustomerJobSiteEdit,
      params: {
        ID: args.JobSite.ID,
        jobsiteId: args.JobSite.ID,
        objDetailData: { ID : args.Customer.ID },
        previewType: "Jobsite"
      },
      tabTitle: "Job Site - " + args.JobSite.DisplayName,
      replaceIfOpen: {
        replaceTab: true,
        tabToReplace: Tabs.FsLiteCustomerJobSiteEdit,
        action: "focus"
      }
    });
  }
  //#endregion
}
